import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';
import {formControlColorStates} from '../shared/form-control-color-states';

export const radioOverrides: Components<Theme>['MuiRadio'] = {
    defaultProps: {
        color: 'info',
    },
    styleOverrides: {
        root: {
            ...formControlColorStates('MuiRadio', {
                Default: {
                    '&.Mui-checked': {
                        color: COLORS.info.main,
                    },
                },
            }),
        },
    },
};
